module.exports = __webpack_public_path__ + "static/img/iphone_ldtpage4.d6e2b74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_ldtpage4.png
// module id = fJ/T
// module chunks = 0